import { NavLink } from 'react-router-dom';
import { useLeague } from '../../features/leagues/api';

/** Sotto-navigazione della lega, landmark separato con aria-current. */
export function LeagueNav({ leagueId }: { leagueId: string }) {
  const league = useLeague(leagueId);
  const isAdmin = league.data?.myRole === 'ADMIN' || league.data?.myRole === 'SUPER_ADMIN';
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-lg px-3 py-2 font-medium no-underline min-h-11 inline-flex items-center ${
      isActive
        ? 'bg-panda-100 text-panda-900 dark:bg-panda-900 dark:text-panda-100'
        : 'text-ink-700 hover:bg-ink-100 dark:text-ink-200 dark:hover:bg-ink-800'
    }`;

  return (
    <nav
      aria-label="Sezioni della lega"
      className="mt-4 flex max-w-full gap-1 overflow-x-auto whitespace-nowrap border-b border-ink-200 pb-3 dark:border-ink-800"
    >
      <NavLink to={`/leghe/${leagueId}`} end className={linkClass}>
        Panoramica
      </NavLink>
      <NavLink to={`/leghe/${leagueId}/giornate`} className={linkClass}>
        Giornate
      </NavLink>
      <NavLink to={`/leghe/${leagueId}/classifica`} className={linkClass}>
        Classifica
      </NavLink>
      <NavLink to={`/leghe/${leagueId}/storico`} className={linkClass}>
        Storico
      </NavLink>
      <NavLink to={`/leghe/${leagueId}/regolamento`} className={linkClass}>
        Regolamento
      </NavLink>
      {isAdmin && (
        <NavLink to={`/leghe/${leagueId}/ammissione`} className={linkClass}>
          Ammissione
        </NavLink>
      )}
    </nav>
  );
}
